// -- import * as _ from "lodash-es"
import * as api from "../../shared/api"
import apiPath from "../../shared/apiPath"
import * as biz_data_helper from "../../shared/biz_data_helper"

const content_type = "SEI_CustTable"
const create = function () {
  return {
    content_type: "muji"
  }
}
const descriptor = {
  name: {
    type: "string",
    required: true,
    validator: (rule, value) => value === "muji"
  },
  age: {
    type: "number",
    asyncValidator: (rule, value) => {
      return new Promise((resolve, reject) => {
        api
          .request({
            url: biz_data_helper.get_endpoint("test_fetch").url,
            parameters: {
              c: "a666"
            }
          })
          .then(res => {


            if (value == res.data[0].echo) {
              resolve(res)
            } else {
              reject("测试没通过")
            }
          })
          .catch(err => {
            reject(err)
          })
      })
    }
  }
}

const biz_data = new biz_data_helper.base_entity_helper(
  content_type,
  create,
  descriptor
)

const fields = {
  default: [
    {
      key: "id",
      label: "编号",
      sortable: true,
      thStyle: {
        width: "60px"
      }
    },
    {
      key: "AccountNum",
      label: "客户帐户",
      sortable: true
    },
    {
      key: "SEI_Name",
      label: "客户名称",
      sortable: true,
      thStyle: {
        width: "15rem"
      }
    },
    {
      key: "SaleAreaid",
      label: "默认销售公司",
      thStyle: {
        width: "14rem"
      },
      sortable: true,
      editable: true
    },
    {
      key: "EmailNotifier",
      label: "邮件通知人",
      thStyle: {
        width: "16rem"
      },
      sortable: true,
      editable: true
    },
    {
      key: "EmailContact",
      label: "联系人邮箱",
      type: "textarea",
      sortable: true,
      editable: true
    },
    {
      key: "EmailNotifierJson",
      label: "邮件通知",
      sortable: true,
      type: "button",
      button: {
        type: "text",
        icon_class: "iconfont icon-email",
        label: "",
        show_label: true
      },
      thStyle: { width: "80px" }
    },
    {
      key: "CustGroup",
      label: "客户组",
      sortable: true
    },
    {
      key: "CustClassificationId",
      label: "客户分类组",
      sortable: true
    },
    {
      key: "SEI_BigCustomerNumber",
      label: "TOP客户组",
      sortable: true
    },
    {
      key: "Currency",
      label: "币种",
      sortable: true
    },
    {
      key: "CreditMax",
      label: "信用额度",
      sortable: true,
      type: "number",
      _precise: 2
    },
    {
      key: "dispUsedCreditAmount",
      label: "已用信用额度",
      sortable: true,
      type: "number",
      _precise: 2
    },
    {
      key: "TaxGroup",
      label: "销售税组",
      sortable: true
    },
    {
      key: "InclTax",
      label: "价格包括销售税",
      sortable: true
    },
    {
      key: "SEI_ContractStartDate",
      label: "合同开始日期",
      sortable: true,
      editable: true,
      type: "date"
    },
    {
      key: "SEI_ContractEndDate",
      label: "合同结束日期",
      sortable: true,
      editable: true,
      type: "date"
    },
    {
      key: "TEC_TaxCustAddress",
      label: "客户地址",
      sortable: true,
      thStyle: {
        width: "20rem"
      }
    },
    {
      key: "PaymDayId",
      label: "付款日",
      sortable: true
    },
    {
      key: "PaymTermId",
      label: "付款期限",
      sortable: true
    },
    {
      key: "SegmentId",
      label: "细分市场",
      sortable: true
    },
    {
      key: "SubsegmentId",
      label: "子细分市场",
      sortable: true
    },
    {
      key: "PartyCountry",
      label: "国家/地区",
      sortable: true
    },
    {
      key: "MainContactWorker",
      label: "负责员工",
      sortable: true
    },
    {
      key: "modifiedDateTime",
      label: "修改日期和时间",
      type: "datetime"
    }
  ],
  detail_fields: [
    {
      key: "dataAreaId",
      label: "公司",
      sortable: true
    },
    {
      key: "CompanyName",
      label: "销售公司名称",
      sortable: true,
      thStyle: { width: "8rem" },
      width: "8rem",
      type: "short"
    },
    {
      key: "AccountNum",
      label: "客户帐户",
      sortable: true
    },
    {
      key: "SEI_Name",
      label: "客户名称",
      sortable: true,
      thStyle: {
        width: "20rem"
      }
    },
    {
      key: "CustGroup",
      label: "客户组",
      sortable: true
    },
    {
      key: "CustClassificationId",
      label: "客户分类组",
      sortable: true
    },
    {
      key: "SEI_BigCustomerNumber",
      label: "TOP客户组",
      sortable: true
    },
    {
      key: "TEC_TaxCustAddress",
      label: "客户地址",
      sortable: true,
      thStyle: {
        width: "25rem"
      }
    },
    {
      key: "MainContactWorker",
      label: "负责员工",
      sortable: true
    },
    // { key: "CreditMax", label: "信用额度", sortable: true },
    {
      key: "Currency",
      label: "币种",
      sortable: true
    },
    {
      key: "SEI_CreditClassificationId",
      label: "信用额度组",
      sortable: true
    },
    {
      key: "CreditRating",
      label: "信用等级",
      sortable: true,
      type: "number"
    },
    {
      key: "TaxGroup",
      label: "销售税组",
      sortable: true
    },
    {
      key: "StatisticsGroup",
      label: "统计组",
      sortable: true
    },
    {
      key: "SalesPoolId",
      label: "销售订单池",
      sortable: true
    },
    {
      key: "InclTax",
      label: "价格包括销售税",
      sortable: true
    },
    {
      key: "DlvTerm",
      label: "交货条款",
      sortable: true
    },
    {
      key: "DlvMode",
      label: "交货方式",
      sortable: true
    },
    {
      key: "PaymTermId",
      label: "付款期限",
      sortable: true
    },
    {
      key: "PaymDayId",
      label: "付款日",
      sortable: true
    },
    {
      key: "CashDiscBaseDays",
      label: "付款期限基准天数",
      sortable: true,
      type: "number"
    },
    {
      key: "ShipCarrierId",
      label: "承运人 ID",
      sortable: true
    },
    {
      key: "SegmentId",
      label: "细分市场",
      sortable: true
    },
    {
      key: "SubsegmentId",
      label: "子细分市场",
      sortable: true
    },
    {
      key: "PartyCountry",
      label: "国家/地区",
      sortable: true
    },
    {
      key: "SEI_1stInvoicedate",
      label: "首次开票日期",
      sortable: true,
      type: "date"
    },
    {
      key: "SEI_1streceivedate",
      label: "首次回款日期",
      sortable: true,
      type: "date"
    },

    {
      key: "SEI_InvoiceTermId",
      label: "开票期限",
      sortable: true
    },
    {
      key: "Blocked",
      label: "开票和交货暂停",
      sortable: true
    },
    {
      key: "SEI_SalesGroup",
      label: "销售团队",
      sortable: true
    },
    {
      key: "InventLocation",
      label: "仓库",
      sortable: true
    },
    {
      key: "createdBy",
      label: "创建人",
      sortable: true
    },
    {
      key: "createdDateTime",
      label: "创建时间",
      sortable: true,
      type: "datetime"
    },
    {
      key: "SEI_modifiedDateTime",
      label: "修改日期和时间",
      type: "datetime"
    }
  ]
}

const dataForm = {}

///前端验证
const rules = {}
const methods = {
  //update 客户合同时间
  async updateCustContractDate(dataList) {
    let actions = []
    _.each(dataList, t => {
      actions.push(
        biz_data
          .updateAction({
            params: t,
            fields: ["id"]
          })
          .action({})
      )
    })
    let result = await api.query_batch({
      actions: actions
    })
    if (
      result &&
      result.data &&
      result.data.BatchResult &&
      result.data.BatchResult.Actions &&
      result.data.BatchResult.Actions.length > 0 &&
      result.data.BatchResult.Actions[0].Result.Data.length > 0
    ) {
      return true
    } else {
      return false
    }
  },
  ///get
  async getData(_params) {
    let _actions = []
    let _new = _.cloneDeep(_params)
    delete _new.id

    //获取信用额度
    const code_biz_data = new biz_data_helper.base_entity_helper(
      "get_customer_credit",
      {},
      {}
    )
    const cust_biz_data = new biz_data_helper.base_entity_helper(
      "get_CustomerInfo",
      {},
      {}
    )

    _actions.push(
      code_biz_data
        .execAction({
          params: {},
          fields: ["AccountNum", "CreditMax", "Temp_CreditMax"]
        })
        .action({})
    )
    _actions.push(
      cust_biz_data
        .execAction({
          params: _params,
          fields: _.map(fields.default, "key")
        })
        .action({})
    )

    let result = await api.query_batch({
      actions: _actions
    })

    if (
      result &&
      result.data &&
      result.data.BatchResult &&
      result.data.BatchResult.Actions &&
      result.data.BatchResult.Actions.length > 0 &&
      result.data.BatchResult.Actions[1].Result &&
      result.data.BatchResult.Actions[1].Result.Data.length > 0
    ) {
      ///计算客户信用额度，信用额度+平台设置的信用额度(仅已审核)+平台临时信用额度(仅已审核)-已使用信用额度
      _.each(result.data.BatchResult.Actions[1].Result.Data[0], t => {
        let _ct = _.find(result.data.BatchResult.Actions[0].Result.Data[0], {
          AccountNum: t.AccountNum
        })
        if (_ct) {
          t.CreditMax = _ct.CreditMax + _ct.Temp_CreditMax ///_ct.dispUsedCreditAmount
        } else {
          t.CreditMax = 0
        }
      })

      return result.data.BatchResult.Actions[1].Result.Data
    } else {
      return null
    }
  },
  ///检查信用额度
  async getCustCredit(_params) {
    let _actions = []
    //获取信用额度
    const code_biz_data = new biz_data_helper.base_entity_helper(
      "get_customer_credit",
      {},
      {}
    )

    _actions.push(
      code_biz_data
        .execAction({
          params: _params,
          fields: ["AccountNum", "CreditMax", "Temp_CreditMax", "overDueDay"]
        })
        .action({})
    )

    let result = await api.query_batch({
      actions: _actions
    })
    let _ct = {
      CreditMax: 0,
      Temp_CreditMax: 0,
      dispUsedCreditAmount: 0,
      overDueDay: false
    }
    if (
      result &&
      result.data &&
      result.data.BatchResult &&
      result.data.BatchResult.Actions &&
      result.data.BatchResult.Actions.length > 0
    ) {
      ///计算客户信用额度，信用额度+平台设置的信用额度(仅已审核)+平台临时信用额度(仅已审核)-已使用信用额度
      _.each(result.data.BatchResult.Actions[0].Result.Data[0], t => {
        if (t) {
          _ct.CreditMax = t.CreditMax
          _ct.Temp_CreditMax = t.Temp_CreditMax
          _ct.dispUsedCreditAmount = t.dispUsedCreditAmount
          _ct.overDueDay = t.overDueDay
        }
      })

      return _ct
    } else {
      return null
    }
  },

  //get item
  async getItemData(_params) {
    const item_biz_data = new biz_data_helper.base_entity_helper(
      "CustTable",
      create,
      descriptor
    )
    let result = await item_biz_data
      .selectAction({
        params: _params,
        fields: _.map(fields.detail_fields, "key")
      })
      .run()

    if (
      result &&
      result[0].result &&
      result[0].result.data &&
      result[0].result.data.ActionResult &&
      result[0].result.data.ActionResult.Result &&
      result[0].result.data.ActionResult.Result.Data.length > 0
    ) {
      return result[0].result.data.ActionResult.Result.Data
    } else {
      return null
    }
  },
  //temp get CustTable
  ///company=070&tableName=secp_sei_custtable&accountNum=100021168,不传则查询所有
  async pickAndInvoke(params) {
    let result = await api.query_async({
      url: apiPath.axInterface.pickand_invoke,
      parameters: params,
      method: "get"
    })
    if (
      result &&
      result[0] &&
      result[0].result &&
      result[0].result.data &&
      result[0].result.data.length > 0
    ) {
      return result[0].result.data[0]
    } else {
      return null
    }
  }
}
export { biz_data, dataForm, fields, methods, rules };

